import { gql } from '@apollo/client';

export const GET_USER = gql`
  query GetUser($id: ID!) {
    User(id: $id) {
      id
      loyaltyName
      loyaltyEmail
      loyaltyRegisteredAt
      loyaltyPoints
      loyaltyConnectedCards {
        id
        createdAt
      }
      loyaltyStampCards {
        currentStampCount
        lastStampedAt
        stampCard {
          id
          name
          stampsRequired
          isActive
        }
      }
      loyaltyCurrentMembershipLevel {
        id
        name
        discountPercentage
        primaryColor
        secondaryColor
      }
      loyaltyNextMembershipLevel {
        id
        name
        requiredPointsToAchieve
      }
    }
  }
`;

/**
 * Everything the POS ever renders about a loyalty member, shared by every way
 * a member can be produced: a card lookup, a search, a refetch, an enrolment.
 */
export const LOYALTY_USER_FRAGMENT = gql`
  fragment LoyaltyUserFields on LoyaltyUser {
    id
    name
    email
    registeredAt
    points
    connectedCards {
      id
      createdAt
    }
    stampCards {
      currentStampCount
      lastStampedAt
      stampCard {
        id
        name
        stampsRequired
        isActive
      }
    }
    currentMembershipLevel {
      id
      name
      discountPercentage
      primaryColor
      secondaryColor
    }
    nextMembershipLevel {
      id
      name
      requiredPointsToAchieve
    }
  }
`;

export const LOYALTY_GENERAL_FIELDS = gql`
  query GetLoyaltyGeneral {
    operativeViewer {
      id
      isLoyaltyFullySetup
    }
  }
`;

/**
 * The card path. Separate from the search operation so a card lookup never
 * overwrites the search step's reactive result list, even though the backend
 * field is the same one.
 */
export const CARD_LOOKUP = gql`
  query LoyaltyCardLookup($search: String!) {
    operativeViewer {
      id
      loyaltyUsers(search: $search, first: 1) {
        ...LoyaltyUserFields
      }
    }
  }
  ${LOYALTY_USER_FRAGMENT}
`;

/**
 * The manual path. The backend matches the term against card tokens, personal
 * identity numbers, emails and names, so one input serves all of them.
 */
export const SEARCH_MEMBERS = gql`
  query LoyaltyUsersSearch($search: String!, $first: Int) {
    operativeViewer {
      id
      loyaltyUsers(search: $search, first: $first) {
        ...LoyaltyUserFields
      }
    }
  }
  ${LOYALTY_USER_FRAGMENT}
`;

export const CREATE_USER = gql`
  mutation CreateUser($data: UserCreateInput!) {
    createUser(data: $data) {
      id
    }
  }
`;

export const UPDATE_MEMBER = gql`
  mutation UpdateLoyaltyUser($updateLoyaltyUserId: ID!, $input: UpdateLoyaltyUserInput!) {
    updateLoyaltyUser(id: $updateLoyaltyUserId, input: $input) {
      id
      message
      success
    }
  }
`;
